import { useState, useCallback, useEffect } from 'react';
import { FetchElements, GetCookie } from '../../../utils/js/request';
import { REQUEST, GET_SELECTED_SHOP_ID } from "../../../utils/js/Const";
import { useNotifications } from '../../../providers/notificationProvider/NotificationProvider';

export const useClaims = (navigate, showAlert) => {

    const [claims, setClaims] = useState([]);
    const [loading, setLoading] = useState(false);
    const { setNotification } = useNotifications();

    // Метод для получения претензий
    const fetchClaims = useCallback(async () => {
        const selectedId = GET_SELECTED_SHOP_ID();
        const accessToken = GetCookie("access_token");

        if (!selectedId || selectedId === 0) {
            console.warn('shops_id не найден:', selectedId);
            setClaims([]);
            return;
        }

        if (!accessToken) {
            console.warn('access_token не найден');
            return;
        }

        setLoading(true);

        try {
            const url = `${REQUEST}/api/v1/pretensions?shops_id=${selectedId}`;

            await FetchElements(
                url,
                'GET',
                (data) => {
                    setClaims(data || []);
                },
                navigate,
                2,
                () => {
                    setClaims([]);
                },
                (title, message, status) => {
                    console.error(`Ошибка API: ${title} - ${message}`, status);
                    if (showAlert) {
                        showAlert(title, message, status);
                    }
                    setClaims([]);
                },
                0,
                null,
                [],
                false
            );
        } catch (error) {
            console.error('Ошибка в fetchClaims:', error);
            setClaims([]);
        } finally {
            setLoading(false);
        }
    }, [navigate, showAlert]);

    // Метод для обновления attachments у претензии
    const updateClaimAttachments = useCallback(
        async (pretensionsGuid, attachmentsGuidArray) => {
            const selectedId = GET_SELECTED_SHOP_ID();
            const accessToken = GetCookie("access_token");

            if (!selectedId || selectedId === 0) {
                console.warn('shops_id не найден:', selectedId);
                throw new Error('ID магазина не найден');
            }

            if (!accessToken) {
                console.warn('access_token не найден');
                throw new Error('Токен доступа не найден');
            }

            if (!pretensionsGuid) {
                console.warn('pretensions_guid обязателен');
                throw new Error('GUID претензии не найден');
            }

            if (!attachmentsGuidArray || !Array.isArray(attachmentsGuidArray)) {
                console.warn('attachments_guid_array должен быть массивом');
                throw new Error('attachments_guid_array должен быть массивом');
            }

            return new Promise((resolve, reject) => {
                const url = `${REQUEST}/api/v1/pretensions/${pretensionsGuid}?shops_id=${selectedId}`;

                FetchElements(
                    url,
                    'PATCH',
                    (data) => {
                        resolve(data);
                    },
                    navigate,
                    2,
                    () => {
                        reject(new Error('Ошибка при обновлении'));
                    },
                    (title, message, status) => {
                        console.error(`Ошибка API: ${title} - ${message}`, status);
                        if (showAlert) {
                            showAlert(title, message, status);
                        }
                        reject(new Error(message));
                    },
                    0,
                    { attachments_guid_array: attachmentsGuidArray },
                    [],
                    false
                );
            });
        },
        [navigate, showAlert]
    );

    // Функция для обновления счетчика
    const fetchClaimsCount = useCallback(async () => {
        const selectedId = GET_SELECTED_SHOP_ID();
        const accessToken = GetCookie("access_token");

        if (!selectedId || selectedId === 0 || !accessToken) {
            console.warn('Нет данных для запроса счетчика');
            return null;
        }

        try {
            const url = `${REQUEST}/api/v1/pretensions/count?shops_id=${selectedId}`;

            const response = await fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Access-Token": accessToken,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                const count = data.data?.count_pretensions || 0;
                setNotification('claims', count);
                return count;
            }
        } catch (error) {
            console.error('Error fetching claims count:', error);
        }
        return null;
    }, [setNotification]);

    return {
        claims,
        loading,
        fetchClaims,
        updateClaimAttachments,
        fetchClaimsCount,
    };
};